// React Imports
import type { SVGAttributes } from 'react';

export const MySidebar = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g id="Icon">
        <g id="Group 1010105157">
          <g id="Group 1010106315">
            <path
              id="Vector"
              d="M14.4 18.26H5V11.87C5 10.87 5.41 9.96 6.06 9.31C6.71 8.66 7.62 8.25 8.62 8.25C10.62 8.25 12.24 9.87 12.24 11.87V14.33H17.3"
              stroke="#424242"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_2"
              d="M8.665 6.58C7.405 6.58 6.375 5.55 6.375 4.29C6.375 3.03 7.405 2 8.665 2C9.925 2 10.955 3.03 10.955 4.29C10.955 5.55 9.925 6.58 8.665 6.58Z"
              fill="#424242"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MySidebarGold = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g id="Icon">
        <g id="Group 1010106316">
          <path
            id="Vector"
            d="M13.4 18.26H4C3.45 18.26 3 17.81 3 17.26V10.87C3 9.64 3.48001 8.48 4.35001 7.6C5.23001 6.73 6.39 6.25 7.62 6.25C10.17 6.25 12.24 8.32 12.24 10.87V12.33H16.3C16.85 12.33 17.3 12.78 17.3 13.33C17.3 13.88 16.85 14.33 16.3 14.33H11.24C10.69 14.33 10.24 13.88 10.24 13.33V10.87C10.24 9.42 9.06 8.25 7.62 8.25C6.92 8.25 6.26 8.52 5.77 9.02C5.28 9.52 5 10.17 5 10.87V16.26H13.4C13.95 16.26 14.4 16.71 14.4 17.26C14.4 17.81 13.95 18.26 13.4 18.26Z"
            fill="url(#paint0_linear_6305_225525)"
          />
          <path
            id="Vector_2"
            d="M7.66499 5.58C6.40499 5.58 5.375 4.55 5.375 3.29C5.375 2.03 6.40499 1 7.66499 1C8.92499 1 9.955 2.03 9.955 3.29C9.955 4.55 8.92499 5.58 7.66499 5.58Z"
            fill="url(#paint1_linear_6305_225525)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6305_225525"
          x1="-0.730001"
          y1="3.73"
          x2="12.48"
          y2="17.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6305_225525"
          x1="3.935"
          y1="-0.670001"
          x2="17.145"
          y2="13.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
      </defs>
    </svg>
  );
};
